<h2 mat-dialog-title>
    <mat-icon class="material-symbols-outlined" style="color:#b73232; vertical-align:middle; margin-right:8px;">lock_clock</mat-icon>
    Gerenciar Fechamento Financeiro
</h2>
<mat-dialog-content>
    <div class="info-box">
        <mat-icon class="material-symbols-outlined info-icon">info</mat-icon>
        <p>O fechamento do período financeiro é indicado para empresas que conferem suas movimentações com frequência.
        Ao fazer esse fechamento, você impede que sejam feitos lançamentos ou alterações em datas anteriores,
        garantindo que o caixa já conferido não seja modificado.</p>
    </div>

    @if (data.dataFechamento) {
    <div class="fechamento-ativo">
        <mat-icon class="fechamento-ativo-icon">warning_amber</mat-icon>
        <span>Os lançamentos no caixa até a data <strong>{{ data.dataFechamento | date:'dd/MM/yyyy' }}</strong> estão bloqueados, pois foi realizado o fechamento do período financeiro.</span>
    </div>
    <div class="acoes-container">
        <button mat-stroked-button class="btn-secondary" (click)="removerFechamento()" [disabled]="_isLoading">
            <mat-icon>lock_open</mat-icon> Remover data de fechamento
        </button>
        <span class="ou-divider">ou</span>
        <span class="label-alterar">Alterar data de fechamento:</span>
    </div>
    }

    <mat-form-field appearance="outline" class="w-100 mt-3">
        <mat-label>Data de fechamento</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="dataCtrl" placeholder="dd/mm/aaaa"
            (input)="onDateInput($event)">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button class="btn-secondary" mat-dialog-close [disabled]="_isLoading">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="salvar()" [disabled]="!dataCtrl.value || _isLoading">
        @if (_isLoading) {
            <mat-spinner diameter="18" style="display:inline-block; margin-right:6px;"></mat-spinner>
        }
        Salvar fechamento
    </button>
</mat-dialog-actions>
